// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1pnIG","dragIcon":"SortableItem_dragIcon__1e1ix","disabled":"SortableItem_disabled__8lSZo"};